import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'openDemoProjectEditor',
  'translateYourVideoClick',
  'translateYourVideoEditorDemoClick',
  'upgradeApplyChangesEditorDemoClick',
  'onboardingFinishedEditorDemo',
  'upgradePlanAccountPageDemo',
  'dashboardOpenTrial',
  'trialProjectOpen',
  'trialProcessingScreenView',
  'upgradeVoiceCloneAccountClick',
  'downloadButtonClick',
  'videoOptionDownloadClick',
  'videoWithSubtitlesOptionDownloadClick',
  'videoWithLipsyncOptionDownloadClick',
  'audioOptionDownloadClick',
  'srtOptionDownloadClick',
  'upgradeToTranslateFullPlayerClick',
  'applyChangesTrialProjectClick',
  'trialPreviewWhatNextItemClick',
  'trialFeatureUpsellModalShown',
  'trialFeatureUpsellModalUnlockClick',
  'trialPricingModalShown',
  'trialPricingModalDismissed',
  'trialPricingModalContinueWithFreeTrialClick',
  'trialPricingModalBookDemoClick',
  'trialPricingModalSwitchAnnual',
  'trialPricingModalSwitchMonthly',
  'trialPricingModalPlanGetStartedClick',
  'trialPreviewUnlockFullAccessClick',
  'trialPreviewExportClick',
  'trialExportPaywallShown',
  'trialExportPaywallUnlockClick',
  'trialExportPaywallShareClick',
  'trialProcessingEmailConsentClick',
  'mobileEditorNoticeShown',
] as const;

export const demoProjectsTrial = getMappedEvents([...EVENTS], {
  shouldSendSubscriptionData: true,
});
